module.exports = __webpack_public_path__ + "static/img/menu3-img2.62c1bc0b.png";